import * as React from "react";
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { DatePicker } from "@mui/lab";

import * as DmsCommon from './../supports/dms-common';

export default function DatePickerWithCheckbox(props) {

  const { dateValue, enabledDate, onDateChange, onEnableDateChange } = props;

  const label = props.label || "Select Date";
  // const [dateValue, setDateValue] = React.useState(null);
  // const [checked, setChecked] = React.useState(false);

  const handleDateChange = (aValue) => {

    const aNewValue = enabledDate ? aValue : null;

    if (onDateChange) {
      onDateChange(aNewValue);
    }
  }

  const handleCheckedChange = (e) => {
    const isChecked = e.target.checked;

    if (onEnableDateChange) {
      onEnableDateChange(isChecked);
    }
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center" }} >
      <Checkbox
        checked={enabledDate}
        onChange={handleCheckedChange}
      />
      <DatePicker
        label={label}
        value={dateValue}
        inputFormat={DmsCommon.SHORT_DATE_FORMAT}

        onChange={handleDateChange}
        disabled={!enabledDate} // disable picker until checkbox is checked
        renderInput={(params) => <TextField
          fullWidth
          {...params}

          InputLabelProps={{ shrink: true, }}
        />}
      />
    </Box>
  );


}

DatePickerWithCheckbox.propTypes = {
  label: PropTypes.string,
  enabledDate: PropTypes.bool,
  dateValue: PropTypes.any,
  onDateChange: PropTypes.func,
  onEnableDateChange: PropTypes.func,
};